import { BufferGeometry, CatmullRomCurve3, ExtrudeGeometry, Shape, Vector2, Vector3 } from 'three';

export const build = (curve: CatmullRomCurve3, segCount: number, size: number) =>
  new ExtrudeGeometry(
    new Shape([new Vector2(-size, -size), new Vector2(size, -size), new Vector2(size, size), new Vector2(-size, size)]),
    {
      curveSegments: segCount,
      extrudePath: curve,
      bevelEnabled: false,
    },
  );

export const lerpGeometries = (
  customCurve1: BufferGeometry,
  customCurve2: BufferGeometry,
  output: BufferGeometry,
  t: number,
) => {
  const positions = output.attributes.position.array;
  for (let i = 0; i < positions.length; i += 3) {
    const customCurve1Positions = customCurve1.attributes.position.array;
    const vertex1 = new Vector3(customCurve1Positions[i], customCurve1Positions[i + 1], customCurve1Positions[i + 2]);

    const customCurve2Positions = customCurve2.attributes.position.array;
    const vertex2 = new Vector3(customCurve2Positions[i], customCurve2Positions[i + 1], customCurve2Positions[i + 2]);

    const lerpedVector = new Vector3().lerpVectors(vertex1, vertex2, t);
    positions[i] = lerpedVector.x;
    positions[i + 1] = lerpedVector.y;
    positions[i + 2] = lerpedVector.z;
  }
  output.attributes.position.needsUpdate = true;
  output.computeBoundingBox();
  output.computeBoundingSphere();
};
